'use strict';

import $ from 'jquery';
import Highcharts from 'highcharts';
import BigNumber from 'bignumber.js';

class TableLibrary {
    constructor() {

    }

    /**
     * 数値のclassを返却
     * @param {type} param 数値
     * @return {String} numClass クラス名
     */
    getNumClass(param) {
        return param < 0 ? 'minus' : 'num';
    }

    /**
     * 決算期の表示形式を変更
     * @param {String} fy 決算期
     * @returns {String}
     */
    convFiscalYear(fy) {
        fy = String(fy);

        return fy.substring(0, 4) + '/' + fy.substring(4, 6);
    }

    /**
     * 数値をカンマ区切りにする
     * @param {Integer} number
     * @param {Integer} decimals
     * @returns {String}
     */
    numberFormat(number, decimals) {
        let pattern = /^[-]?([1-9]\d*|0)$/;
        if (!pattern.test(decimals)) {
            decimals = 0;
        }

        return number === null ? '－' : Highcharts.numberFormat(number, decimals, '.', ',');
    }
}

export const tableLib = new TableLibrary();
